/* Charmies "اصنعي باقتك" Build-Your-Bundle. Port of src/components/site/BundleBuilder.tsx.
 * Each slot picks Type (Bag/Slippers/Horse) → Color → Scent from that source product.
 * Adds ONE charmies-bundle tier line with the pieces as properties via CharmiesCart.addBundle. */
(function () {
  'use strict';
  var root = document.getElementById('charmies-bundle-builder');
  if (!root) return;
  var controls = root.querySelector('[data-bb-controls]');
  if (!controls) return;

  var isAr = ((window.CHARMIES || {}).locale === 'ar');
  var money = (window.CharmiesCart && window.CharmiesCart.money) || function (n) { return isAr ? Number(n).toFixed(2) + ' QAR' : 'QAR ' + Number(n).toFixed(2); };
  var SCENTS = window.CHARMIES_SCENTS || [];
  var TIERS = (window.CHARMIES_BUNDLE_TIERS || []).slice().sort(function (a, b) { return a.qty - b.qty; });
  var MAX = 3;
  if (!TIERS.length) { controls.innerHTML = '<p class="text-sm text-muted-foreground">' + (isAr ? 'الباقات غير متوفرة حالياً.' : 'Bundles are currently unavailable.') + '</p>'; return; }
  var CHECK ='<svg aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var CHEV_DOWN = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>';
  var CHEV_UP = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m18 15-6-6-6 6"/></svg>';
  var APPLE_LOGO = '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M17.05 12.53c-.02-2.4 1.96-3.55 2.05-3.61-1.12-1.64-2.86-1.86-3.48-1.89-1.48-.15-2.89.87-3.64.87-.75 0-1.91-.85-3.14-.83-1.62.02-3.11.94-3.94 2.39-1.68 2.92-.43 7.24 1.2 9.61.8 1.16 1.75 2.46 3 2.41 1.2-.05 1.66-.78 3.11-.78 1.45 0 1.86.78 3.14.75 1.3-.02 2.12-1.18 2.91-2.35.92-1.35 1.3-2.66 1.32-2.73-.03-.01-2.53-.97-2.55-3.85zM14.63 5.16c.66-.8 1.11-1.91.99-3.02-.95.04-2.11.64-2.8 1.44-.61.71-1.15 1.84-1.01 2.92 1.06.08 2.15-.54 2.82-1.34z"/></svg>';
  var AR_D = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

  function L(en, ar) { var b = window.charmiesT; return (b && b[en] != null) ? b[en] : (isAr ? ar : en); }
  function arabicNum(n) { return String(n).split('').map(function (d) { return AR_D[+d] != null ? AR_D[+d] : d; }).join(''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function err(m) { if (window.CharmiesCart && window.CharmiesCart.toastError) window.CharmiesCart.toastError(m); else alert(m); }
  // True only on Apple Pay-capable devices/browsers (Safari on Apple hardware). We show the
  // express button just for them; everyone else sees only Add-to-Cart / Buy-it-now.
  function applePayAvailable() {
    try { return !!(window.ApplePaySession && window.ApplePaySession.canMakePayments && window.ApplePaySession.canMakePayments()); }
    catch (e) { return false; }
  }
  function colorEntry(n) { var s = (n || '').trim().toLowerCase(); return (window.CHARMIES_COLORS || []).find(function (c) { return c.en.toLowerCase() === s || c.ar === n; }); }
  function colorAr(n) { var e = colorEntry(n); return e ? e.ar : n; }
  function colorEnOf(n) { var e = colorEntry(n); return e ? e.en : n; }
  function colorHex(n) { var e = colorEntry(n); return e ? e.hex : null; }
  // Name comes straight from the Shopify product title (already localised per storefront locale) — no hardcoded list.
  function typeName(handle) { var s = sourceByHandle(handle); var nm = (s && s.name) || handle; return { en: nm, ar: nm }; }
  function scentById(id) { return SCENTS.find(function (s) { return s.id === id; }); }
  function flashScentHint() {
    var hint = controls.querySelector('[data-bb-scent-hint]');
    if (!hint) return;
    hint.classList.remove('hidden');
    clearTimeout(hint.__t);
    hint.__t = setTimeout(function () { hint.classList.add('hidden'); }, 2800);
  }

  // Sources with at least one in-stock colour (Lovable: availableSources)
  var SOURCES = (window.CHARMIES_BUNDLE_SOURCES || []).filter(function (s) { return s.colors.some(function (c) { return !c.oos; }); });
  function sourceByHandle(h) { return SOURCES.find(function (s) { return s.handle === h; }); }
  function colorIn(src, name) { return src ? src.colors.find(function (c) { return c.name === name; }) : null; }
  function findVariant(src, colorEn, scentEn) {
    if (!src) return null;
    var c = (colorEn || '').trim().toLowerCase(), s = (scentEn || '').trim().toLowerCase();
    return src.variants.find(function (v) { return (v.color || '').trim().toLowerCase() === c && (v.scent || '').trim().toLowerCase() === s; }) || null;
  }
  function thumbForSource(src) {
    var pick = src.colors.find(function (c) { return /black|أسود/i.test(c.name); })
      || src.colors.find(function (c) { return !c.oos; }) || src.colors[0];
    return (pick && pick.image) || src.images[0] || '';
  }

  var bestTier = TIERS.find(function (t) { return t.bestDeal; }) || TIERS[TIERS.length - 1] || { qty: 3 };
  var state = { qty: bestTier.qty, active: 0, slots: [], tierOpen: true };
  function tierByQty(q) { return TIERS.find(function (t) { return t.qty === q; }) || TIERS[0]; }

  // ── DYNAMIC pricing (charms can now have different base prices, e.g. Special Bag 125) ──
  // price = sum(picked charm base prices) × tier discount, rounded UP to the next "…8".
  // The discount % is derived from the admin Duo/Trio prices, so editing them in Shopify flows through.
  var STEPS = window.CHARMIES_PRICE_STEPS || [];
  var SINGLE_BASE = (tierByQty(1) || {}).price || 99;
  function tierMult(q) { var t = tierByQty(q); return (t && SINGLE_BASE) ? (t.price / (SINGLE_BASE * q)) : 1; }
  function round8(x) { return Math.ceil(x / 10) * 10 - 2; }
  function slotBase(s) { var src = s && s.handle ? sourceByHandle(s.handle) : null; return (src && src.base) || SINGLE_BASE; }
  function baseSum() { var t = 0; state.slots.forEach(function (s) { t += slotBase(s); }); return t; }
  function bundlePrice(q, sum) { return q <= 1 ? sum : round8(sum * tierMult(q)); }
  function livePrice() { return bundlePrice(state.qty, baseSum()); }
  function stepFor(price) { var p = Math.round(price); for (var i = 0; i < STEPS.length; i++) { if (Math.round(STEPS[i].price) === p) return STEPS[i]; } return null; }
  function syncSlots() {
    var next = [];
    for (var i = 0; i < state.qty; i++) next.push(state.slots[i] || { handle: '', color: '', scent: '' });
    state.slots = next;
    state.active = Math.max(0, Math.min(state.active, state.qty - 1));
  }
  syncSlots();
  function isComplete() { return state.slots.length > 0 && state.slots.every(function (s) { return s.handle && s.color && s.scent; }); }

  // ── ViewContent pixel ──
  if (window.CharmiesPixels) window.CharmiesPixels.viewContent({ contentName: 'Build Your Bundle', items: [], value: bestTier.price });

  // ── gallery ──
  function slotImage(slot) {
    if (!slot || !slot.handle) return null;
    var src = sourceByHandle(slot.handle); if (!src) return null;
    var col = colorIn(src, slot.color);
    return (col && col.image) || src.images[0] || null;
  }
  function renderGallery() {
    var main = root.querySelector('[data-bb-main]');
    var thumbs = root.querySelector('[data-bb-thumbs]');
    var fallback = (window.CHARMIES_BUNDLE_IMAGES && window.CHARMIES_BUNDLE_IMAGES[0]) || (SOURCES[0] && SOURCES[0].images[0]) || '';
    var active = state.slots[state.active];
    var mainImg = slotImage(active) || fallback;
    if (main) {
      if (mainImg) {
        var mimg = main.querySelector('img');
        if (!mimg) { main.innerHTML = '<img alt="" class="h-full w-full object-cover">'; mimg = main.querySelector('img'); }
        if (mimg.getAttribute('src') !== mainImg) mimg.setAttribute('src', mainImg);
      } else { main.innerHTML = ''; }
    }
    if (thumbs) {
      thumbs.innerHTML = state.slots.map(function (s, i) {
        var img = slotImage(s);
        var on = i === state.active;
        return '<button type="button" data-bb-thumb="' + i + '" class="grid h-20 w-20 flex-shrink-0 place-items-center overflow-hidden rounded-2xl border-2 transition ' + (on ? 'border-primary' : 'border-transparent opacity-80') + (img ? '' : ' bg-muted/40') + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" class="h-full w-full object-cover">' : '<span class="text-sm font-bold text-muted-foreground">' + (i + 1) + '</span>') + '</button>';
      }).join('');
    }
  }

  function render() {
    var tier = tierByQty(state.qty);
    // Every charm is a flat 99 and each bundle bills a FIXED tier price, so the price / "was" /
    // savings shown are the tier's fixed values — never a half-computed number while the shopper
    // is still filling slots (that caused "2 pieces · 98"). Billing already uses tier.price.
    var live = tier.price;
    var wasPrice = tier.originalPrice || 0;
    var savePct = tier.savingsPct || 0;
    var html = '';
    // Tier selector — full cards until the shopper picks, then a slim summary bar (tap to re-open)
    // so the choice takes minimal space and the charm selection sits higher (kills the up/down scroll).
    if (state.tierOpen) {
      html += '<div class="relative my-4 flex items-center"><div class="h-px flex-1 bg-border"></div><span class="mx-3 text-sm font-semibold tracking-wide">' + L('Special Offer', 'عرض خاص') + '</span><div class="h-px flex-1 bg-border"></div></div>';
      html += '<div class="grid grid-cols-3 gap-3">';
      TIERS.forEach(function (t) {
        var sel = t.qty === state.qty;
        html += '<button type="button" data-bb-tier="' + t.qty + '" aria-pressed="' + sel + '" class="relative rounded-2xl border-2 p-3 text-center transition ' + (sel ? 'border-primary bg-primary/5 shadow-md' : 'border-border bg-card/60') + '">' +
          (t.bestDeal ? '<span class="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-primary px-3 py-0.5 text-[10px] font-bold text-primary-foreground">' + L('Best Deal', 'أفضل عرض') + '</span>' : '') +
          '<div class="mx-auto mb-2 grid h-5 w-5 place-items-center rounded-lg border-2 transition ' + (sel ? 'border-primary bg-primary text-primary-foreground' : 'border-muted-foreground/40') + '">' + (sel ? CHECK : '') + '</div>' +
          '<div class="text-sm font-bold">' + esc(isAr ? t.labelAr : t.labelEn) + '</div><div class="mt-1 text-xs text-muted-foreground">×' + (isAr ? arabicNum(t.qty) : t.qty) + '</div>' +
          '<div class="mt-2 text-sm font-bold">' + esc(money(t.price)) + '</div>' +
          (t.originalPrice ? '<div class="text-[11px] text-muted-foreground line-through">' + esc(money(t.originalPrice)) + '</div>' : '') +
          (t.savingsPct ? '<div class="mt-1 text-[11px] font-semibold text-rose-deep">' + L('You save', 'وفّر') + ' ' + t.savingsPct + '%</div>' : '') +
          (t.price >= 200 ? '<div class="mt-1 text-[11px] font-semibold" style="color:#0a8a3f">' + L('🚚 Free shipping', '🚚 توصيل مجاني') + '</div>' : '') + '</button>';
      });
      html += '</div>';
    } else {
      html += '<button type="button" data-bb-tier-toggle class="mt-4 flex w-full items-center justify-between gap-2 rounded-2xl border-2 border-primary bg-primary/5 px-4 py-3 text-start transition hover:bg-primary/10">' +
        '<span class="flex min-w-0 items-center gap-2">' +
          '<span class="grid h-6 w-6 flex-shrink-0 place-items-center rounded-full bg-primary text-[11px] font-bold text-primary-foreground">' + (isAr ? arabicNum(state.qty) : state.qty) + '</span>' +
          '<span class="truncate text-sm font-bold text-primary">' + esc(isAr ? tier.labelAr : tier.labelEn) + ' · ' + esc(money(live)) + '</span>' +
          (savePct ? '<span class="flex-shrink-0 rounded-full bg-rose-deep px-2 py-0.5 text-[10px] font-bold text-white">' + (isAr ? 'وفّري ' + arabicNum(savePct) + '٪' : 'Save ' + savePct + '%') + '</span>' : '') +
        '</span>' +
        '<span class="flex flex-shrink-0 items-center gap-1 text-xs font-semibold text-muted-foreground">' + L('Change', 'تغيير') + CHEV_DOWN + '</span>' +
      '</button>';
    }

    // Progress — how many items are ready (guides the shopper to finish the bundle)
    var doneCount = state.slots.filter(function (s) { return s.handle && s.color && s.scent; }).length;
    html += '<div class="mt-4 flex items-center gap-2 text-xs font-semibold text-muted-foreground">' +
      '<span class="whitespace-nowrap">' + L(doneCount + ' of ' + state.qty + ' ready', arabicNum(doneCount) + ' من ' + arabicNum(state.qty) + ' جاهزة') + '</span>' +
      '<div class="h-1.5 flex-1 overflow-hidden rounded-full bg-muted"><div class="h-full rounded-full bg-primary transition-all" style="width:' + Math.round(doneCount / state.qty * 100) + '%"></div></div>' +
      '</div>';

    // Slot cards (accordion)
    html += '<div class="mt-3 space-y-3">';
    state.slots.forEach(function (slot, i) {
      var open = state.active === i;
      var src = sourceByHandle(slot.handle);
      var col = colorIn(src, slot.color);
      var sc = scentById(slot.scent);
      var complete = slot.handle && slot.color && slot.scent;
      var label = L('Item', 'العنصر') + ' ' + (isAr ? arabicNum(i + 1) : (i + 1));
      html += '<div class="rounded-2xl border bg-card ' + (complete ? 'border-border' : 'border-primary/40') + '">';
      html += '<button type="button" data-bb-toggle="' + i + '" class="flex w-full items-center justify-between gap-3 p-3"><div class="flex items-center gap-3">' +
        '<div class="grid h-10 w-10 place-items-center rounded-full text-xs font-bold transition ' + (complete ? 'text-white' : 'bg-primary text-primary-foreground') + '"' + (complete ? ' style="background:#16a34a"' : '') + '>' + (complete ? CHECK : (isAr ? arabicNum(i + 1) : (i + 1))) + '</div>' +
        '<div class="text-start text-sm"><div class="font-semibold">' + esc(label) + '</div>' +
        (complete
          ? '<div class="text-xs text-muted-foreground">' + esc((isAr ? typeName(slot.handle).ar : typeName(slot.handle).en) + ' · ' + (isAr ? colorAr(col.name) : col.name) + ' · ' + (isAr ? sc.ar : sc.en)) + '</div>'
          : '<div class="text-xs text-muted-foreground">' + L('Pick type, color, scent', 'اختاري النوع واللون والعطر') + '</div>') +
        '</div></div><div class="flex items-center gap-2">' +
        ((!open && !complete) ? '<span class="rounded-full bg-primary px-2.5 py-1 text-[11px] font-semibold text-primary-foreground">' + L('Choose', 'اختاري') + '</span>' : '') +
        (open ? CHEV_UP : CHEV_DOWN) + '</div></button>';

      if (open) {
        html += '<div class="space-y-5 border-t border-border p-4 sm:p-5">';
        // Type
        html += '<div><div class="mb-3 text-xs font-semibold uppercase tracking-wide text-muted-foreground">' + L('Type', 'النوع') + '</div>';
        var typeBtn = function (s, isPrem) {
          var on = slot.handle === s.handle;
          var thumb = thumbForSource(s);
          return '<button type="button" data-bb-type="' + esc(s.handle) + '" class="flex flex-col items-center gap-1 rounded-xl border-2 p-2 transition ' + (on ? 'border-primary bg-primary/5' : 'border-border hover:border-primary/40') + '">' +
            (thumb ? '<img src="' + esc(thumb) + '" alt="" class="h-12 w-12 rounded-lg object-cover">' : '') +
            '<span class="text-xs font-medium">' + (isPrem ? '<span class="text-rose-deep">★</span> ' : '') + esc(isAr ? typeName(s.handle).ar : typeName(s.handle).en) + '</span></button>';
        };
        var regularTypes = SOURCES.filter(function (s) { return (s.base || SINGLE_BASE) <= SINGLE_BASE; });
        var premiumTypes = SOURCES.filter(function (s) { return (s.base || SINGLE_BASE) > SINGLE_BASE; });
        html += '<div class="grid grid-cols-3 gap-2.5">';
        regularTypes.forEach(function (s) { html += typeBtn(s, false); });
        html += '</div>';
        if (premiumTypes.length) {
          html += '<div class="mt-4 rounded-2xl bg-blush/40 p-3 ring-1 ring-rose-soft/40">' +
            '<div class="mb-2.5 flex items-center gap-1.5 text-xs font-bold text-rose-deep">★ ' + esc(L('Make it premium', 'اجعليها مميزة')) + '</div>' +
            '<div class="grid grid-cols-3 gap-2.5">';
          premiumTypes.forEach(function (s) { html += typeBtn(s, true); });
          html += '</div></div>';
        }
        html += '</div>';
        // Color (only if type chosen)
        if (src) {
          html += '<div><div class="mb-2 flex items-center justify-between"><span class="text-xs font-semibold uppercase tracking-wide text-muted-foreground">' + L('Color', 'اللون') + '</span>' +
            (col ? '<span class="text-xs text-muted-foreground">' + esc(isAr ? colorAr(col.name) : col.name) + '</span>' : '') + '</div><div class="flex flex-wrap gap-2">';
          src.colors.forEach(function (c) {
            var on = slot.color === c.name;
            var cName = isAr ? colorAr(c.name) : c.name;
            var chex = colorHex(c.name) || c.hex;
            html += '<button type="button" data-bb-color="' + esc(c.name) + '" aria-label="' + esc(cName) + '" aria-pressed="' + on + '" title="' + (c.oos ? esc(L('Coming soon', 'قريباً')) : esc(cName)) + '"' + (c.oos ? ' disabled' : '') +
              ' class="relative grid h-11 w-11 place-items-center overflow-hidden rounded-full border-2 bg-muted transition ' + (on ? 'border-primary scale-110 ring-2 ring-primary/30' : 'border-border') + (c.oos ? ' opacity-40 grayscale cursor-not-allowed' : '') + '" style="' + (c.image ? "background-image:url(" + esc(c.image) + ");background-size:cover;background-position:center" : 'background:' + esc(chex)) + '">' +
              (on ? '<span class="relative z-10 grid h-5 w-5 place-items-center rounded-full bg-primary text-primary-foreground shadow">' + CHECK + '</span>' : '') + '</button>';
          });
          html += '</div></div>';
        }
        // Scent
        var hasColor = !!col;
        var scentHint = !src ? L('Pick a charm first', 'اختاري النوع أولاً') : L('Choose your colour first', 'اختاري اللون أولاً');
        html += '<div><div class="mb-3 text-xs font-semibold uppercase tracking-wide text-muted-foreground">' + L('Choose a scent', 'اختاري العطر') + '</div>';
        html += '<p data-bb-scent-hint class="mb-2 hidden text-xs font-semibold text-rose-deep">' + esc(scentHint + ' 🎨') + '</p>';
        html += '<div class="grid grid-cols-2 gap-2.5 sm:grid-cols-4">';
        SCENTS.forEach(function (s) {
          var on = slot.scent === s.id;
          var unavailable = false; // real "coming soon" only after a colour is chosen (non-gift charms)
          if (hasColor && !(src && src.hasScent === false)) { var variant = findVariant(src, col.name, isAr ? s.ar : s.en); unavailable = !variant || !variant.available; }
          var cls = 'grid min-h-11 place-items-center rounded-xl border-2 px-2 py-3 text-xs font-medium transition ';
          if (on) { cls += 'border-primary bg-primary/10 text-primary'; }
          else if (unavailable) { cls += 'border-border opacity-40 cursor-not-allowed line-through'; }
          else { cls += 'border-border hover:border-primary/40'; }
          var bestSeller = s.id === 'miss-coco' && !unavailable;
          var bestBadge = bestSeller ? '<span aria-hidden="true" style="position:absolute;top:-7px;left:50%;transform:translateX(-50%);white-space:nowrap;background:#f5b833;color:#4a2c17;font-size:8.5px;line-height:1.2;font-weight:800;letter-spacing:.02em;padding:2px 7px;border-radius:999px;box-shadow:0 1px 3px rgba(20,20,45,.22);z-index:2">★ ' + (isAr ? 'الأكثر مبيعاً' : 'Best Seller') + '</span>' : '';
          html += '<button type="button" data-bb-scent="' + s.id + '"' + (hasColor ? '' : ' data-needs-color="1"') + ' aria-pressed="' + on + '"' + (unavailable ? ' disabled' : '') +
            (bestSeller ? ' style="position:relative"' : '') +
            ' class="' + cls + '">' + bestBadge + esc(isAr ? s.ar : s.en) + '</button>';
        });
        html += '</div></div></div>';
      }
      html += '</div>';
    });
    html += '</div>';

    // Order summary
    html += '<div data-bb-summary class="mt-4 rounded-2xl bg-blush/50 p-4 ring-1 ring-rose-soft/40"><div class="mb-2 flex items-center justify-between gap-3"><div class="text-sm font-semibold text-primary">' + L('Your bundle', 'باقتك') + '</div>' +
      (savePct ? '<span class="rounded-full bg-rose-deep px-2.5 py-0.5 text-[10px] font-bold text-white">' + (isAr ? 'توفير ' + arabicNum(savePct) + '٪' : 'Save ' + savePct + '%') + '</span>' : '') + '</div><ul class="space-y-1 text-sm">';
    state.slots.forEach(function (slot, i) {
      var src = sourceByHandle(slot.handle), col = colorIn(src, slot.color), sc = scentById(slot.scent);
      var filled = slot.handle && slot.color && slot.scent;
      var itemBase = filled ? slotBase(slot) : 0;
      html += '<li class="flex items-baseline justify-between gap-2"><span class="min-w-0 whitespace-normal break-words">' + (isAr ? arabicNum(i + 1) : (i + 1)) + '. ' +
        (filled ? esc((isAr ? typeName(slot.handle).ar : typeName(slot.handle).en) + ' · ' + (isAr ? colorAr(col.name) : col.name) + ' · ' + (isAr ? sc.ar : sc.en)) : '<span class="italic text-muted-foreground">' + L('Not selected yet', 'لم تُختر بعد') + '</span>') + '</span>' +
        (filled ? '<span class="shrink-0 whitespace-nowrap text-xs text-muted-foreground">' + esc(money(itemBase)) + '</span>' : '') + '</li>';
    });
    html += '</ul><div class="mt-3 flex items-baseline justify-between border-t border-rose-soft/40 pt-2 font-semibold"><span>' + L('Total', 'المجموع') + '</span><span class="text-right"><span class="text-base">' + esc(money(live)) + '</span>' +
      (wasPrice > live ? '<span class="ms-2 text-xs font-normal text-muted-foreground line-through">' + esc(money(wasPrice)) + '</span>' : '') + '</span></div></div>';

    // CTAs
    var dis = !isComplete();

    // Express Apple Pay — sits right under the order summary, above Add-to-Cart / Buy-it-now.
    // Only rendered on Apple Pay-capable devices. It adds the bundle then jumps straight to
    // Shopify checkout, where Apple Pay is a single tap. (A dynamic phantom variant can't open
    // the in-page Apple Pay sheet from theme code, so this is the honest fast path.)
    if (applePayAvailable()) {
      html += '<button type="button" data-bb-applepay' + (dis ? ' disabled' : '') + ' aria-label="' + esc(L('Pay with Apple Pay', 'ادفعي عبر Apple Pay')) + '" class="mt-4 flex w-full items-center justify-center gap-2 rounded-2xl py-4 text-base font-semibold text-white transition hover:opacity-90 disabled:opacity-50 sm:py-5" style="background:#000">' +
        APPLE_LOGO + '<span>' + esc(L('Pay', 'Pay')) + '</span></button>';
    }

    html += '<div class="sticky bottom-0 z-30 -mx-4 mt-4 grid grid-cols-2 gap-2 border-t border-border bg-background/95 px-4 py-3 pb-safe backdrop-blur sm:static sm:mx-0 sm:flex sm:flex-col sm:gap-2 sm:border-0 sm:bg-transparent sm:p-0">' +
      '<button type="button" data-bb-add' + (dis ? ' disabled' : '') + ' class="w-full rounded-2xl border-2 border-primary bg-card py-4 text-sm font-semibold text-primary transition hover:bg-primary/10 disabled:opacity-50 sm:py-5 sm:text-base">' + (dis ? L('Complete every item', 'أكملي اختيار كل قطعة') : L('Add to Cart', 'أضف إلى السلة') + ' · ' + esc(money(live))) + '</button>' +
      '<button type="button" data-bb-buy' + (dis ? ' disabled' : '') + ' class="w-full rounded-2xl bg-primary py-4 text-sm font-semibold text-primary-foreground transition hover:bg-primary/90 disabled:opacity-50 sm:py-5 sm:text-base">' + L('Buy it now', 'اشترِ الآن') + ' · ' + esc(money(live)) + '</button></div>';

    controls.innerHTML = html;
    renderGallery();
  }

  // Re-render while keeping the item the shopper is looking at pinned to the same spot on
  // screen. A full innerHTML rebuild otherwise shifts content above the fold (a drawer
  // collapsing/expanding changes height), which makes the page "jump" so the shopper has to
  // scroll back to where they were. We measure the anchor drawer's on-screen position before
  // and after the rebuild, then correct the scroll by the delta — instant and invisible.
  function renderStable(anchorIdx) {
    var sel = (anchorIdx != null && anchorIdx > -1) ? '[data-bb-toggle="' + anchorIdx + '"]' : null;
    var before = null;
    if (sel) { var e0 = controls.querySelector(sel); if (e0) before = e0.getBoundingClientRect().top; }
    render();
    if (before != null) {
      var e1 = controls.querySelector(sel);
      if (e1 && window.scrollBy) {
        var delta = e1.getBoundingClientRect().top - before;
        if (delta) window.scrollBy(0, delta);
      }
    }
  }

  // Smooth, DETERMINISTIC scroll used after an item is completed: bring a target (the next
  // item's header, or the order summary) to just under the sticky site header. Always the same
  // predictable move, so the shopper is guided to the next step instead of being thrown to a
  // random spot (the old "nudge if off-screen" logic could scroll UP when the next header was
  // above the fold — that was the confusing jump).
  function bbScrollTo(target) {
    if (!target || !target.getBoundingClientRect) return;
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hdr = document.querySelector('.shopify-section-group-header-group') || document.querySelector('header');
    var offset = 14 + (hdr && hdr.offsetHeight ? Math.min(hdr.offsetHeight, 140) : 72);
    var y = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) - offset;
    window.scrollTo({ top: Math.max(0, y), behavior: rm ? 'auto' : 'smooth' });
  }

  function buildLine() {
    var tier = tierByQty(state.qty);
    var slots = [];
    for (var i = 0; i < state.slots.length; i++) {
      var s = state.slots[i];
      var src = sourceByHandle(s.handle), col = colorIn(src, s.color), sc = scentById(s.scent);
      var variant = findVariant(src, col.name, (src.hasScent === false) ? null : (isAr ? sc.ar : sc.en));
      if (!variant) { err(L("That combination isn't available", 'هذه التركيبة غير متوفرة حالياً')); return null; }
      var tn = typeName(src.handle);
      slots.push({ typeEn: tn.en, typeAr: tn.ar, colorEn: colorEnOf(col.name), colorAr: colorAr(col.name), scentEn: sc.en, scentAr: sc.ar, image: col.image || src.images[0] || '', variantId: variant.id });
    }
    var origSum = 0;
    for (var j = 0; j < state.slots.length; j++) { origSum += slotBase(state.slots[j]); }
    var live = bundlePrice(state.qty, origSum);
    var billVariantId, billPrice = live;
    if (state.qty <= 1) {
      billVariantId = slots[0] ? slots[0].variantId : tier.variantId; // single: bill the real charm variant at its real price (99)
    } else {
      // Every charm is a uniform 99 now, so a bundle is always exactly its fixed tier price (Duo 158, Trio 198).
      // Bill the clean tier variant directly — no phantom price-ladder variant to match, one less thing to fail.
      billVariantId = tier.variantId;
      billPrice = tier.price;
    }
    return { tierVariantId: billVariantId, bundleLabelEn: tier.labelEn, bundleLabelAr: tier.labelAr, totalPrice: billPrice, nameEn: 'Build Your Bundle', nameAr: 'اصنعي باقتك', image: slots[0] ? slots[0].image : '', slots: slots };
  }

  var bbAdvance = null;
  controls.addEventListener('click', function (e) {
    if (bbAdvance) { clearTimeout(bbAdvance); bbAdvance = null; } // any tap cancels a pending auto-advance
    var tt = e.target.closest('[data-bb-tier]');
    if (tt) { state.qty = parseInt(tt.getAttribute('data-bb-tier'), 10); state.tierOpen = false; syncSlots(); renderStable(state.active); return; }
    var ttog = e.target.closest('[data-bb-tier-toggle]');
    if (ttog) { state.tierOpen = true; render(); return; }
    var tg = e.target.closest('[data-bb-toggle]');
    if (tg) { var i = parseInt(tg.getAttribute('data-bb-toggle'), 10); state.active = (state.active === i ? -1 : i); renderStable(i); return; }
    var ty = e.target.closest('[data-bb-type]');
    if (ty) { state.slots[state.active].handle = ty.getAttribute('data-bb-type'); state.slots[state.active].color = ''; state.tierOpen = false; renderStable(state.active); return; }
    var cc = e.target.closest('[data-bb-color]');
    if (cc && !cc.disabled) {
      var slot = state.slots[state.active];
      var newColor = cc.getAttribute('data-bb-color');
      slot.color = newColor;
      // Drop a now-incompatible scent (real-scent charms only). Free-gift scent persists across colours.
      var src = sourceByHandle(slot.handle);
      if (src && src.hasScent !== false) {
        var col = colorIn(src, newColor), curScent = scentById(slot.scent);
        var v = (col && curScent) ? findVariant(src, col.name, isAr ? curScent.ar : curScent.en) : null;
        if (!v || !v.available) slot.scent = '';
      }
      renderStable(state.active); return;
    }
    var ss = e.target.closest('[data-bb-scent]');
    if (ss && !ss.disabled) {
      var sslot = state.slots[state.active];
      if (!sslot.color) { flashScentHint(); return; } // no colour yet -> gentle nudge, don't select
      sslot.scent = ss.getAttribute('data-bb-scent');
      renderStable(state.active); // immediate: the just-finished item flips to a green ✓ so the shopper SEES it's done — pinned so the page doesn't jump
      // Then, after a short beat, gently open the next unfinished item (so it doesn't snap away too fast to notice).
      if (sslot.handle && sslot.color && sslot.scent) {
        var bbDone = state.active; // the item that was just finished — keep it pinned so nothing jumps
        var bbNext = -1;
        for (var bk = 0; bk < state.slots.length; bk++) {
          if (bk !== state.active && !(state.slots[bk].handle && state.slots[bk].color && state.slots[bk].scent)) { bbNext = bk; break; }
        }
        bbAdvance = setTimeout(function () {
          bbAdvance = null;
          state.active = bbNext; // -1 when every item is done -> collapse the last one too
          render();
          // Guide the shopper to the next step: the next item to fill, or — when the whole
          // bundle is done — the order summary (the Add-to-Cart / Buy bar stays pinned at the
          // bottom on mobile). One smooth, predictable move; never a surprise up-jump.
          var target = (bbNext > -1)
            ? controls.querySelector('[data-bb-toggle="' + state.active + '"]')
            : controls.querySelector('[data-bb-summary]');
          bbScrollTo(target);
        }, 500);
      }
      return;
    }
    var add = e.target.closest('[data-bb-add]');
    var buy = e.target.closest('[data-bb-buy]');
    var pay = e.target.closest('[data-bb-applepay]');
    if (add || buy || pay) {
      if (!isComplete()) { err(L('Complete every item', 'أكملي اختيار كل قطعة')); return; }
      var line = buildLine(); if (!line) return;
      if (buy || pay) {
        var b = buy || pay, orig = b.innerHTML; b.disabled = true; b.innerHTML = L('...', 'جارٍ...');
        window.CharmiesCart.addBundle(line, { express: true })
          .then(function (cart) { return window.CharmiesCart.checkout(cart); }) // pass the settled cart -> no second settle
          .catch(function () { b.disabled = false; b.innerHTML = orig; err(L('Checkout failed', 'تعذر إنشاء الطلب')); });
      } else {
        window.CharmiesCart.addBundle(line).catch(function (ex) { err((ex && ex.data && ex.data.description) || L('Sorry — could not add to cart. Please try again.', 'عذراً، تعذّرت الإضافة إلى السلة. حاولي مرة أخرى.')); });
      }
    }
  });

  root.addEventListener('click', function (e) {
    var th = e.target.closest('[data-bb-thumb]');
    if (!th) return;
    state.active = parseInt(th.getAttribute('data-bb-thumb'), 10);
    renderStable(state.active);
  });

  // If the shopper taps Apple Pay / Buy-it-now then presses BACK, the browser can restore this
  // page from its back-forward cache with the button still frozen on "…". Re-render on that
  // restore so the buttons reset to their normal state instead of looking stuck.
  window.addEventListener('pageshow', function (e) { if (e.persisted && !bbAdvance) render(); });

  render();
})();
